import { POSLogo } from '@publicisgroupe/p-os-components';
import { Icon } from 'semantic-ui-react';
import { t } from 'utils/resources';

interface MobileViewProps {
  showLandscape: boolean;
  showLoginBackground: boolean;
  showLoginContent: boolean;
  backgroundImage: string;
  loginRedirect: () => void;
}
export const LoginMobileView = ({
  showLandscape,
  showLoginBackground,
  showLoginContent,
  backgroundImage,
  loginRedirect,
}: MobileViewProps) => {
  return (
    <div className="mobile-view">
      <div
        className={`${showLandscape ? ' hide-background ' : ''} ${
          showLoginBackground ? ' fadeIn ' : ' fadeOut '
        }`}
      >
        <div
          className="sunset-bg"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          <div className={showLoginContent ? 'fadeIn' : 'fadeOut'}>
            <div className="mobile-login-brand">
              <div className="POS_Image_small">
                <POSLogo className="pgos-img" color="colored" inverted />
              </div>
              <p className="logo-description">{t('Login.LogoDescription')} </p>
              <button className="login-btn" onClick={() => loginRedirect()}>
                {t('Login.Button')}
              </button>
            </div>
            <div className="page-footer">
              <div className="footer-text">
                {t('Login.RequestAccess')}
                <br />
                <a>
                  {t('Login.BottomContent')}
                  <Icon name="angle right"></Icon>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
